import { React, useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import { ReactComponent as CalanderSvg } from '../../image/Calander.svg';
import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';
import { ReactComponent as DoubleLeftArrowSvg } from '../../image/DoubleLeftArrow.svg';
import { ReactComponent as ExitSvg } from '../../image/BlackExit.svg';

const LockerCalenderInput = forwardRef((props, ref) => {
  const { className, value, setValue, clickFn, disabled, width } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [today, setToday] = useState(value);
  const [isClicked, setIsClicked] = useState(false);
  const [dateList, setDateList] = useState([]);
  // const [value, setValue] = useState('');

  const CalenderRef = useRef();

  const firstWeek = today.clone().startOf('month').week();
  const lastWeek = today.clone().endOf('month').week() === 1 ? 53 : today.clone().endOf('month').week();

  useImperativeHandle(ref, () => ({
    setValue: (val) => {
      setValue(val)
    },
    getValue: () => {
      return value;
    },
    closeCalender: () => {
      setIsClicked(false);
    }
  }));

  useEffect(() => {
    setToday(value);
  }, [value])

  useEffect(() => {
    let newDateList = [];

    for (let week = firstWeek; week <= lastWeek; week++) {
      for (let i = 0; i < 7; i++) {
        let days = today.clone().startOf('year').week(week).startOf('week').add(i, 'day');
        
        newDateList.push(days);
      } 
    }
    setDateList(newDateList);

    if (isClicked) {
      // CalenderRef.current.style.height = `405px`;
      CalenderRef.current.style.height = `${118 + 56 * (newDateList.length / 7)}px`;
      CalenderRef.current.style.border = `1px solid ${theme.primary}`;
      CalenderRef.current.style.zIndex = `2`;
      CalenderRef.current.style.opacity = `1`;
    }
    else {
      CalenderRef.current.style.height = `0px`;
      CalenderRef.current.style.border = `0px solid ${theme.primary}`;
      CalenderRef.current.style.zIndex = `-3`;
      CalenderRef.current.style.opacity = `0`;
    }
  }, [isClicked, today, firstWeek, lastWeek, theme]) 

  function inputClick() {
    if (disabled) return;
    
    setIsClicked(!isClicked);
    // setToday(moment());
    clickFn(className);
  }

  function dateClick(index) {
    setValue(dateList[index])
    setIsClicked(false);
  }

  return (
    <TopLevelWrapper>
      <Input onClick={inputClick} disabled={disabled} width={width}>
        <StyledCalander />
        <Text black={value !== '' ? true : false}>
          {value.format(t('memberDetail.membershipEditModal.dateFormat'))}
        </Text>
      </Input>
      <CalenderView ref={CalenderRef}>
        <ButtonWrapper>
          <TitleWrapper>
            <ArrowButton onClick={() => setToday(today.clone().subtract(1, 'year'))} style={{ margin: `0 -7px 0 0` }}>
              <StyledDoubleArrow />
            </ArrowButton>
            <ArrowButton onClick={() => setToday(today.clone().subtract(1, 'month'))}>
              <StyledArrow />
            </ArrowButton>
            <Title>{today.format('YYYY년 MM월')}</Title>
            <ArrowButton onClick={() => setToday(today.clone().add(1, 'month'))}>
              <StyledArrow isRight />
            </ArrowButton>
            <ArrowButton onClick={() => setToday(today.clone().add(1, 'year'))} style={{ margin: `0 0 0 -7px` }}>
              <StyledDoubleArrow isRight />
            </ArrowButton>
          </TitleWrapper>
          <ExitButton onClick={() => setIsClicked(false)}>
            <StyledExitIcon color={theme.text} />
          </ExitButton>
        </ButtonWrapper>
        <DateColumnWrapper>
          <DateColumn style={{ width: `25px`, marginRight: `36px` }}>SUN</DateColumn>
          <DateColumn style={{ width: `30px`, marginRight: `34px` }}>MON</DateColumn>
          <DateColumn style={{ width: `23px`, marginRight: `36px` }}>TUE</DateColumn>
          <DateColumn style={{ width: `28px`, marginRight: `35px` }}>WED</DateColumn>
          <DateColumn style={{ width: `25px`, marginRight: `42px` }}>THU</DateColumn>
          <DateColumn style={{ width: `18px`, marginRight: `40px` }}>FRI</DateColumn>
          <DateColumn style={{ width: `24px`, marginRight: `28px` }}>SAT</DateColumn>
        </DateColumnWrapper>
        <DateWrapper>
          {
            dateList.map((data, index) => (
              data.format('MM') === today.format('MM') ?
              <Date key={index} onClick={() => dateClick(index)}>
                  {data.format('D')}
              </Date>
              :
              <WithoutHoverDate key={index}>
                  {data.format('D')}
              </WithoutHoverDate>
            ))
          }
        </DateWrapper>
      </CalenderView>
    </TopLevelWrapper>
  )
})

export default LockerCalenderInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Input = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px;

  // width: 280px;
  width: calc(${props => props.width}px - 18px);
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.disabled ? props.theme.line : props.theme.subBackground};

  gap: 10px;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.black ? props.theme.text : props.theme.subText};

  margin: 0;
`;

const CalenderView = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  border: 0px solid ${props => props.theme.primary};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  z-index: -30;
  opacity: 0;

  overflow: hidden;

  margin-top: 38px;
  
  transition: all 0.3s ease-in-out;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 28px;
  padding: 0px 22px 0px 22px;

  width: calc(100% - 44px);
`;

const ExitButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  &:hover {
    cursor: pointer;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 6px;
  // margin: 28px 0 0 22px;
`;

const ArrowButton = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;
  
  &:hover {
    cursor: pointer;
  }
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const DateColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  // justify-content: center;
  // align-items: center;

  // gap: 38px;
  margin-top: 29px;
  margin-left: 28px;
  margin-bottom: 23px;
`;

const DateColumn = styled.p`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  font-family: Poppins-bold;
  font-size: 12px;

  color: ${props => props.theme.primary};
  
  margin: 0 0 0 0;
`;

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  width: 448px;
  margin-left: 8px;
`;

const Date = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;

  border-radius: 48px;

  margin: 0 7px 5px 7px;

  background-color: ${props => props.theme.subBackground};
  
  font-family: Poppins-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.primary};
    color: ${props => props.theme.white};

    font-fmaily: Poppins-Bold;
    font-size: 14px;
  }
`;

const WithoutHoverDate = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 48px;
  height: 48px;

  border-radius: 48px;

  margin: 0 7px 5px 7px;

  background-color: ${props => props.theme.subBackground};

  font-family: Poppins-Regular;
  font-size: 14px;

  color: ${props => props.theme.line};

  &:hover {
    cursor: default;
  }
`;

const StyledCalander = styled(CalanderSvg)`
  flex-shrink: 0;
  width: 18px;
  height: 18px;

  & path {
    fill: ${props => props.theme.text};
  }
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 12px;
  height: 12px;
  transform: ${({ isRight }) => (isRight ? 'rotate(180deg)' : 'none')};

  & path {
    fill: ${props => props.theme.text};
  }
`;

const StyledDoubleArrow = styled(DoubleLeftArrowSvg)`
  width: 22px;
  height: 22px;
  transform: ${({ isRight }) => (isRight ? 'rotate(180deg)' : 'none')};

  & path {
    fill: ${props => props.theme.text};
  }
`;

const StyledExitIcon = styled(ExitSvg)`
  width: 24px;
  height: 24px;

  path {
    fill: ${({ color }) => color};
  }
`;
